import _classCallCheck from "/home/runner/work/makeschool-com-marketing/makeschool-com-marketing/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/runner/work/makeschool-com-marketing/makeschool-com-marketing/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/home/runner/work/makeschool-com-marketing/makeschool-com-marketing/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/home/runner/work/makeschool-com-marketing/makeschool-com-marketing/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/home/runner/work/makeschool-com-marketing/makeschool-com-marketing/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import { CloudinaryTransformable } from "./CloudinaryTransformable";
import { VideoTransformation } from "../transformation/VideoTransformation";
/**
 * @desc Cloudinary video asset, with video-related transformations
 * @summary SDK
 * @memberOf SDK
 */

var CloudinaryVideo = /*#__PURE__*/function (_CloudinaryTransforma) {
  _inherits(CloudinaryVideo, _CloudinaryTransforma);

  var _super = _createSuper(CloudinaryVideo);

  function CloudinaryVideo(publicID, cloudConfig, urlConfig) {
    var _this;

    _classCallCheck(this, CloudinaryVideo);

    /* istanbul ignore next */
    _this = _super.call(this, publicID, cloudConfig, urlConfig, new VideoTransformation());
    _this.assetType = 'video';
    return _this;
  }
  /**
   * @desc A proxy to {@link SDK.Transformation| Transformation} - Calls the same method contained in this.transformation
   * @param {Actions.Transcode} action
   * @return {this}
   */


  _createClass(CloudinaryVideo, [{
    key: "transcode",
    value: function transcode(action) {
      this.transformation.transcode(action);
      return this;
    }
    /**
     * @desc A proxy to {@link SDK.Transformation| Transformation} - Calls the same method contained in this.transformation
     * @param {Actions.VideoEdit} action
     * @return {this}
     */

  }, {
    key: "videoEdit",
    value: function videoEdit(action) {
      this.transformation.videoEdit(action);
      return this;
    }
  }]);

  return CloudinaryVideo;
}(CloudinaryTransformable);

export { CloudinaryVideo };